module.exports = __webpack_public_path__ + "img/stand height.fef538b8.png";